import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import SelectableBarComponent from './SelectableBarComponent'

const propTypes = {
  bars: PropTypes.array.isRequired,
  selectedBar: PropTypes.object,
  onBarSelection: PropTypes.func.isRequired,
  currentTransaction: PropTypes.object
}

class BarSelectionComponent extends Component {
  render() {
    const { bars, selectedBar, currentTransaction } = this.props
    return (
      <Grid
        style={{ padding: 16 }}
        container
        direction="row"
        alignItems="center"
        justify="center">
        {bars.map((bar, index) => {
          const isSelected = selectedBar && selectedBar.key === bar.key
          return (
            <Grid item key={bar.key}>
              <SelectableBarComponent
                bar={bar}
                currentTransaction={currentTransaction}
                selectable={
                  !isSelected &&
                  !!bar.currentTransaction &&
                  !!bar.currentTransaction.sale_id
                }
                isSelected={isSelected}
                onSelect={this.props.onBarSelection}
              />
            </Grid>
          )
        })}
      </Grid>
    )
  }
}

BarSelectionComponent.propTypes = propTypes
export default BarSelectionComponent



// WEBPACK FOOTER //
// ./src/components/SelectionTabsComponent/BarSelectionComponent.js